<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/financeCODOrdersList/">COD Orders</a></li>
      <li class="breadcrumb-item active" aria-current="page">Payment Processing</li>
    </ol>
  </nav>
  <div class="row mt-3">
    <div class="col">
      <div class="inner-box">
        <h2 class="text-black text-center"><b>Payment Processing for {{g.codAccountOwnerName}}</b></h2>
        <div class="row mt-3">
          <div class="p-3">
            <label class="text-black"><b>Orders</b> :{{g.ordersIds}}</label>
          </div>

          <div class="row">
            <div class="col-md-3 p-3">
              <label class="text-black"><b>Amount</b> :{{sum}} </label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 form-group">
              <label class="control-label" for="date">Transaction Date</label>
              <input (blur)="typeTranDate()" type="date" name="date" id="date" [(ngModel)]="transactionDate"
                     [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':transactionDateError}"
                     class="form-control " value="1">
              <div [hidden]="!transactionDateError" class="invalid-feedback d-block shift-invalid-login"
                   id="transactionDateError">
                {{transactionDateError}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 form-group">
              <label class="control-label" for="accountNo">Transaction ref no :</label>
              <input (blur)="typeTransactionNo()" [(ngModel)]="transactionNo"
                     [ngModelOptions]="{standalone :true}" [ngClass]="{'is-invalid':transactionNumberError}"
                     class="form-control"
                     id="accountNo" maxlength="20"
                     required type="text" appOnlyNumbers>
              <div [hidden]="!transactionNumberError" class="invalid-feedback d-block shift-invalid-login"
                   id="transactionNumberError">
                {{transactionNumberError}}
              </div>
            </div>
          </div>

          <div class="col text-right p-2">
            <button class="btn btn-orange" type="submit" (click)="saveCodInfo()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
